import * as type from "../../types";

const initialState = {
  mode: localStorage.getItem("leadMode") || "retail",
};

const NewLeadModeReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_LEAD_MODE:
      localStorage.setItem("leadMode", action.payload);
      return {
        ...state,
        mode: action.payload,
      };

    case type.RESET_LEAD_MODE:
      localStorage.removeItem("leadMode");
      return {
        ...state,
        mode: "retail",
      };

    default:
      return state;
  }
};

export default NewLeadModeReducer;
